"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var auth_suite_config_1 = require("@cbsi-cbscom/auth-suite-config");
var ProdEnvConfigPrototype = /** @class */ (function (_super) {
    tslib_1.__extends(ProdEnvConfigPrototype, _super);
    function ProdEnvConfigPrototype() {
        return _super.call(this, ProdEnvConfigPrototype.regionToAuthSuiteUrl, "https://api.auth.adobe.com", "https://musicjsonpath-a.akamaihd.net") || this;
    }
    ProdEnvConfigPrototype.regionToAuthSuiteUrl = new Map([
        [auth_suite_config_1.NetworkRegion.EU, "https://eu.auth.mtvnservices.com"],
        [auth_suite_config_1.NetworkRegion.GLOBAL, "https://auth.mtvnservices.com"],
    ]);
    return ProdEnvConfigPrototype;
}(auth_suite_config_1.EnvConfigPrototype));
var envConfig = new ProdEnvConfigPrototype();
auth_suite_config_1.configBase.setConfig(envConfig.build());
console.log("AuthSuite SDK set up with config [PROD]: ", JSON.stringify(envConfig));
exports.default = envConfig;
